export enum State {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
}

export enum Stateable {
  LegalEntity = 'LegalEntity',
  Employee = 'Employee',
  Document = 'Document',
}
